import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { accountType } from "custom-prop-types";
import { fetchUserSettingsAction } from "actions/user-settings-actions";
import { SettingsInlineTabs } from "components/settings/settings-inline-tabs";
import grid from "components/grid.scss";
import styles from "components/settings/settings.scss";
import { UserSettingsMenu } from "components/settings/user-settings-menu";

class UserSettings extends React.Component {
  componentWillMount() {
    this.props.init();
  }
  render() {
    return (
      <div className={ styles.container }>
        <SettingsInlineTabs currentPage="user" slug={ this.props.slug } />
        <div className={ grid.row }>
          <div className={ `${styles["grid-spacing"]} ${grid["col-md-1"]}` } />
          <div className={ `${styles["grid-spacing"]} ${grid["col-md-2"]}` }>
            <UserSettingsMenu accounts={ this.props.accounts } slug={ this.props.slug } />
          </div>
          <div className={ `${styles["grid-spacing"]} ${grid["col-md-8"]}` }>
            <div className={ styles["child-container"] }>
              { this.props.children }
            </div>
          </div>
          <div className={ `${styles["grid-spacing"]} ${grid["col-md-1"]}` } />
        </div>
      </div>
    );
  }
}

UserSettings.propTypes = {
  accounts: PropTypes.arrayOf(accountType).isRequired,
  children: PropTypes.element.isRequired,
  init: PropTypes.func.isRequired,
  slug: PropTypes.string.isRequired
};

const mapStateToProps = (state) => ({
  accounts: state.app.accounts,
  accountId: state.app.selectedAccount.id,
  slug: state.app.selectedAccount.slug
});

const mapDispatchToProps = (dispatch) => ({
  init: () => dispatch(fetchUserSettingsAction())
});

export const UserSettingsContainer = connect(mapStateToProps, mapDispatchToProps)(UserSettings);



// WEBPACK FOOTER //
// ./src/js/containers/settings/user-settings-container.jsx